module.exports = __webpack_public_path__ + "static/media/MONEY.7b637439.png";